import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
	selectStatus(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/selectStatus',
			method: 'post',
			data: param,
		})
	},
  selectDevice(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/selectDevice',
      method: 'post',
      data: param,
    })
  },
  selectName(param) {
    return request({
      url: store.getters.getPostUrl + 'organization/user?id='+param,
      method: 'post',
    })
  },
	selectInspectionPage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/pageAll',
			method: 'post',
			data: param,
		})
	},
	updateStatus(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/updateStatus',
			method: 'post',
			data: param,
		})
	},
	del(param) {
		return request({
			url: store.getters.getPostUrl + '/mes/equipmentInspectionPlan',
			method: 'delete',
			data: param
		})
	},
	selectTimeData(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionTime/list',
			method: 'post',
			data: param,
		})
	},
	timeAddSave(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionTime/insert',
		  method: 'post',
		  data:param
		})
	},
	timeUpdateSave(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionTime/update',
		  method: 'post',
		  data:param
		})
	},
	timeDelete(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionTime/delete',
		  method: 'delete',
		  params:{'id': param}
		})
	},
	saveInspectionRest(param) {
	  return request({
		url: store.getters.getPostUrl + 'mes/equipmentInspectionRest/update',
		method: 'post',
		data: param
	  })
	},
	selectRest(param) {
	  return request({
		url: store.getters.getPostUrl + 'mes/equipmentInspectionRest/selectById',
		method: 'post',
		data: param
	  })
	},
	add(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/insert',
		  method: 'post',
		  data: param
		})
	},
	selectInspInfo(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/selectInspInfo',
		  method: 'post',
		  params:{'equipmentId': param}
		})
	},
	sort1(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/inspDeviceSort',
		  method: 'post',
		  params: param
		})
	},
	sort2(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/inspInfoSort',
		  method: 'post',
		  params: param
		})
	},
	inspDeviceAdd(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionPlan/inspDeviceAdd',
		  method: 'post',
		  data: param
		})
	},
	selectRecordStatus(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionRecord/status',
		  method: 'post',
		  data: param
		})
	},
	selectInspectionRecordPage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionRecord/pageAll',
			method: 'post',
			data: param,
		})
	},
	selectDetail(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentInspectionRecord/detail',
			method: 'post',
			params:{'id': param}
		})
	},
	selectDetailInfo(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/equipmentInspectionRecord/detailInfo',
		  method: 'post',
		  params: param
		})
	},
	statistics(param){
	    return request({
	      url: store.getters.getPostUrl + 'mes/equipmentInspectionRecord/statistics',
	      method: 'post',
	      data: param
	    })
	  },
	statisticsList(param){
		return request({
	      url: store.getters.getPostUrl + 'mes/equipmentInspectionRecord/statisticsList',
	      method: 'post',
	      data: param
		})
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/inspection/inspection.js